import React, { useEffect } from 'react';
import '../styles/Platforms.css';

const platforms = [
  {
    title: "1xbet",
    image: "1xbet.webp",
  },
  {
    title: "10CRIC",
    image: "10cric.webp",
  },
  {
    title: "Cricketbet99",
    image: "cricketbet99.webp",
  },
  {
    title: "Dafabet",
    image: "Dafabet_ReddyAnna.webp",
  },
  {
    title: "Fun88 India",
    image: "FUN88_ReddyAnna.webp",
  },
  {
    title: "Laser247",
    image: "laser.webp",
  },
  {
    title: "Parimatch",
    image: "Parimatch_ReddyAnna.webp",
  },
  {
    title: "Stake",
    image: "Stake_ReddyAnna.webp",
  },
  {
    title: "11xPlay",
    image: "11xplayplatforms.webp",
  },
];

const Platforms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (
    <div className="platforms-page">
      <header className="platforms-hero-section">
        <h1 className="platforms-hero-title">Our <span className='highlight'>Platforms</span></h1>
        <p className="platforms-hero-description">
          Immerse yourself in the ultimate cricket betting experience with Reddy Anna platforms! Feel the adrenaline of every match, boost your winnings with expert guidance, and enjoy advanced features designed for your success. Join today and embark on a thrilling betting adventure like no other!
        </p>
      </header>

      <section className="platforms-section">
        <h2 className="platforms-section-title">All <span className='highlight'>Reddy Anna</span> Platforms</h2>
        <div className="platforms-grid">
          {platforms.map((platform, index) => (
            <div className="platform-card" key={index}>
              <div className="platform-image">
                <img
                  src={platform.image}
                  alt={platform.title}
                />
              </div>
              <div className="platform-name">{platform.title}</div>
            </div>
          ))}
        </div>
        <div className="platforms-btn">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default Platforms;
